import { LocationSearchCriteria } from "../../../types";

const hasValue = (criteria: LocationSearchCriteria): boolean => {
  const { specialtyIds } = criteria?.locationCriteria?.location ?? {};
  return (specialtyIds && specialtyIds.length > 0) || false;
};

const clearValue = (
  updateCriteria: (criteria: LocationSearchCriteria) => void
) => {
  updateCriteria({
    locationCriteria: {
      location: {
        specialtyIds: undefined,
      },
    },
  });
};

const render = () => <></>;

export const secteurFilter = {
  hasValue,
  clearValue,
  render,
};
